import { render, staticRenderFns } from "./CreatingBackupModal.vue?vue&type=template&id=0f996dec&scoped=true"
import script from "./CreatingBackupModal.vue?vue&type=script&lang=ts"
export * from "./CreatingBackupModal.vue?vue&type=script&lang=ts"
import style0 from "./CreatingBackupModal.vue?vue&type=style&index=0&id=0f996dec&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f996dec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f996dec')) {
      api.createRecord('0f996dec', component.options)
    } else {
      api.reload('0f996dec', component.options)
    }
    module.hot.accept("./CreatingBackupModal.vue?vue&type=template&id=0f996dec&scoped=true", function () {
      api.rerender('0f996dec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/CreatingBackupModal.vue"
export default component.exports